import { memo, useCallback } from 'react';
import { formatDate } from '@diezhi/momo';
import { isMobile, isLatestNews } from '@@/utils';
import styles from './style.module.scss';

const NewsList = ({
  data,
}) => {
  const onClickDetail = useCallback((e) => {
    const { id } = e.currentTarget.dataset;
    if (id === undefined) return;
    const url = `${window.location.origin}${isMobile() ? '/m' : ''}/news/${id}`;
    window.open(url);
  }, []);

  return (
    <div className={styles.newsList}>
      {data.map((item) => (
        <div key={item.id} className={styles.item} data-id={item.id} onClick={onClickDetail}>
          <div className={styles.hoverImg} />
          <div className={styles.date}>{formatDate(new Date(item.publish_time), 'YY-MM-DD').formatTime}</div>
          <div className={styles.titleWrap}>
            {isLatestNews(item.publish_time) && <div className={styles.latest}>[最新]</div>}
            <div className={styles.title}>{item.title}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

NewsList.defaultProps = {
  data: [],
};

export default memo(NewsList);
